// src/modules/goldInventory/api.js
import API from '../../services/api';

export const fetchBatches = ({ page = 1, limit = 10, status = '', branch = '' } = {}) =>
  API.get('/gold-inventory', {
    params: { page, limit, ...(status ? { status } : {}), ...(branch ? { branch } : {}) },
  }).then((r) => r.data);

export const getBatchById = (id) =>
  API.get(`/gold-inventory/${id}`).then((r) => r.data);

export const createBatch = (data) =>
  API.post('/gold-inventory', data).then((r) => r.data);

export const deleteBatch = (id) =>
  API.delete(`/gold-inventory/${id}`).then((r) => r.data);

export const getVaultSummary = (branch) =>
  API.get('/gold-inventory/summary', { params: { ...(branch ? { branch } : {}) } }).then((r) => r.data);

// ── Invoice profile (seller / bank / terms / declaration) ──
export const getInvoiceProfile = () =>
  API.get('/gold-inventory/invoice-profile').then((r) => r.data);

export const updateInvoiceProfile = (data) =>
  API.put('/gold-inventory/invoice-profile', data).then((r) => r.data);
